import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';
import { CardColor } from '@/api/workspaceSettings/queries';

const { registerReducer } = useStorymapStore();

export class ChangeColorFilter extends Action<StorymapState> {
    public static ACTION_TYPE = 'ChangeColorFilter';

    public constructor(public color: CardColor) {
        super(ChangeColorFilter.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: ChangeColorFilter): void => {
    if (state.filterState.colors.includes(action.color)) {
        state.filterState.colors = state.filterState.colors.filter((x) => x !== action.color);
    } else {
        state.filterState.colors.push(action.color);
    }
};

//@ts-ignore
registerReducer(ChangeColorFilter.ACTION_TYPE, reducer);